module.exports = __webpack_public_path__ + "static/media/spain.78215071.svg";